// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.3 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.\\!m-0 {
  margin: 0px !important;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-\\[80px\\] {
  margin-top: 80px;
  margin-bottom: 80px;
}
.\\!ml-\\[-10px\\] {
  margin-left: -10px !important;
}
.\\!ml-\\[-8px\\] {
  margin-left: -8px !important;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-2\\.5 {
  margin-bottom: 0.625rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.mb-\\[150px\\] {
  margin-bottom: 150px;
}
.mb-\\[15px\\] {
  margin-bottom: 15px;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-\\[-12px\\] {
  margin-left: -12px;
}
.ml-\\[-9px\\] {
  margin-left: -9px;
}
.ml-\\[0px\\] {
  margin-left: 0px;
}
.ml-\\[20px\\] {
  margin-left: 20px;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-2\\.5 {
  margin-right: 0.625rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-5 {
  margin-right: 1.25rem;
}
.mr-\\[10px\\] {
  margin-right: 10px;
}
.mr-\\[20px\\] {
  margin-right: 20px;
}
.mt-0 {
  margin-top: 0px;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-7 {
  margin-top: 1.75rem;
}
.mt-\\[0\\.7px\\] {
  margin-top: 0.7px;
}
.mt-\\[13\\.5px\\] {
  margin-top: 13.5px;
}
.mt-\\[15px\\] {
  margin-top: 15px;
}
.mt-\\[19\\.5px\\] {
  margin-top: 19.5px;
}
.mt-\\[20px\\] {
  margin-top: 20px;
}
.block {
  display: block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.\\!h-\\[100px\\] {
  height: 100px !important;
}
.\\!h-\\[300px\\] {
  height: 300px !important;
}
.\\!h-fit {
  height: -moz-fit-content !important;
  height: fit-content !important;
}
.\\!h-full {
  height: 100% !important;
}
.h-\\[150px\\] {
  height: 150px;
}
.h-\\[20px\\] {
  height: 20px;
}
.h-\\[24px\\] {
  height: 24px;
}
.h-\\[25px\\] {
  height: 25px;
}
.h-\\[2px\\] {
  height: 2px;
}
.h-\\[30px\\] {
  height: 30px;
}
.h-\\[36px\\] {
  height: 36px;
}
.h-\\[4\\.5rem\\] {
  height: 4.5rem;
}
.h-full {
  height: 100%;
}
.h-screen {
  height: 100vh;
}
.max-h-\\[350px\\] {
  max-height: 350px;
}
.\\!w-\\[100px\\] {
  width: 100px !important;
}
.\\!w-\\[500px\\] {
  width: 500px !important;
}
.\\!w-full {
  width: 100% !important;
}
.w-1\\/2 {
  width: 50%;
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[120px\\] {
  width: 120px;
}
.w-\\[130px\\] {
  width: 130px;
}
.w-\\[200px\\] {
  width: 200px;
}
.w-\\[20px\\] {
  width: 20px;
}
.w-\\[24px\\] {
  width: 24px;
}
.w-\\[25px\\] {
  width: 25px;
}
.w-\\[30px\\] {
  width: 30px;
}
.w-\\[50\\%\\] {
  width: 50%;
}
.w-\\[60px\\] {
  width: 60px;
}
.w-full {
  width: 100%;
}
.\\!min-w-\\[48\\%\\] {
  min-width: 48% !important;
}
.min-w-\\[156px\\] {
  min-width: 156px;
}
.min-w-full {
  min-width: 100%;
}
.max-w-\\[450\\.63px\\] {
  max-width: 450.63px;
}
.max-w-\\[470\\.63px\\] {
  max-width: 470.63px;
}
.max-w-\\[700px\\] {
  max-width: 700px;
}
.max-w-fit {
  max-width: -moz-fit-content;
  max-width: fit-content;
}
.max-w-full {
  max-width: 100%;
}
.cursor-pointer {
  cursor: pointer;
}
.resize {
  resize: both;
}
.list-disc {
  list-style-type: disc;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-7 {
  gap: 1.75rem;
}
.gap-\\[10px\\] {
  gap: 10px;
}
.gap-\\[15px\\] {
  gap: 15px;
}
.gap-\\[18px\\] {
  gap: 18px;
}
.gap-\\[21px\\] {
  gap: 21px;
}
.gap-\\[2px\\] {
  gap: 2px;
}
.gap-\\[5px\\] {
  gap: 5px;
}
.self-start {
  align-self: flex-start;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.break-words {
  overflow-wrap: break-word;
}
.rounded-\\[13px\\] {
  border-radius: 13px;
}
.rounded-\\[20px\\] {
  border-radius: 20px;
}
.rounded-\\[30px\\] {
  border-radius: 30px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-md {
  border-radius: 0.375rem;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-\\[1px\\] {
  border-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-t-2 {
  border-top-width: 2px;
}
.border-none {
  border-style: none;
}
.\\!border-\\[\\#D7D8E4\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(215 216 228 / var(--tw-border-opacity)) !important;
}
.border-\\[\\#D7D8E4\\] {
  --tw-border-opacity: 1;
  border-color: rgb(215 216 228 / var(--tw-border-opacity));
}
.border-\\[\\#ededed\\] {
  --tw-border-opacity: 1;
  border-color: rgb(237 237 237 / var(--tw-border-opacity));
}
.border-\\[blue\\] {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 255 / var(--tw-border-opacity));
}
.border-blue-300 {
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.border-b-\\[\\#e5e5e5\\] {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(229 229 229 / var(--tw-border-opacity));
}
.\\!bg-\\[\\#F6F7FF\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(246 247 255 / var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#483ea3\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(72 62 163 / var(--tw-bg-opacity));
}
.bg-\\[\\#C3F4E5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(195 244 229 / var(--tw-bg-opacity));
}
.bg-\\[\\#E9EBED\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(233 235 237 / var(--tw-bg-opacity));
}
.bg-\\[\\#F6F7FF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(246 247 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#f5f5f5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity));
}
.bg-gray-400\\/40 {
  background-color: rgb(156 163 175 / 0.4);
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}
.bg-slate-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.object-cover {
  object-fit: cover;
}
.\\!p-0 {
  padding: 0px !important;
}
.p-3 {
  padding: 0.75rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-\\[15px\\] {
  padding: 15px;
}
.p-\\[1px\\] {
  padding: 1px;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-\\[10px\\] {
  padding-left: 10px;
  padding-right: 10px;
}
.px-\\[13px\\] {
  padding-left: 13px;
  padding-right: 13px;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-\\[10px\\] {
  padding-top: 10px;
  padding-bottom: 10px;
}
.py-\\[15px\\] {
  padding-top: 15px;
  padding-bottom: 15px;
}
.py-\\[23px\\] {
  padding-top: 23px;
  padding-bottom: 23px;
}
.py-\\[5px\\] {
  padding-top: 5px;
  padding-bottom: 5px;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-\\[10px\\] {
  padding-bottom: 10px;
}
.pb-\\[13\\.5px\\] {
  padding-bottom: 13.5px;
}
.pb-\\[17px\\] {
  padding-bottom: 17px;
}
.pb-\\[30px\\] {
  padding-bottom: 30px;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-\\[15px\\] {
  padding-left: 15px;
}
.pt-0 {
  padding-top: 0px;
}
.pt-\\[10px\\] {
  padding-top: 10px;
}
.pt-\\[19\\.5px\\] {
  padding-top: 19.5px;
}
.pt-\\[20px\\] {
  padding-top: 20px;
}
.pt-\\[2px\\] {
  padding-top: 2px;
}
.pt-\\[8px\\] {
  padding-top: 8px;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-justify {
  text-align: justify;
}
.text-start {
  text-align: start;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[18px\\] {
  font-size: 18px;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-\\[22px\\] {
  font-size: 22px;
}
.text-\\[28px\\] {
  font-size: 28px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-\\[400\\] {
  font-weight: 400;
}
.font-\\[500\\] {
  font-weight: 500;
}
.font-\\[600\\] {
  font-weight: 600;
}
.font-\\[700\\] {
  font-weight: 700;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.capitalize {
  text-transform: capitalize;
}
.not-italic {
  font-style: normal;
}
.leading-5 {
  line-height: 1.25rem;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-\\[14\\.4px\\] {
  line-height: 14.4px;
}
.leading-\\[14px\\] {
  line-height: 14px;
}
.leading-\\[15\\.78px\\] {
  line-height: 15.78px;
}
.leading-\\[16\\.8px\\] {
  line-height: 16.8px;
}
.leading-\\[16px\\] {
  line-height: 16px;
}
.leading-\\[17\\.64px\\] {
  line-height: 17.64px;
}
.leading-\\[17px\\] {
  line-height: 17px;
}
.leading-\\[18\\.41px\\] {
  line-height: 18.41px;
}
.leading-\\[19\\.36px\\] {
  line-height: 19.36px;
}
.leading-\\[20\\.16px\\] {
  line-height: 20.16px;
}
.leading-\\[22\\.68px\\] {
  line-height: 22.68px;
}
.leading-\\[22px\\] {
  line-height: 22px;
}
.leading-\\[24\\.11px\\] {
  line-height: 24.11px;
}
.leading-\\[25\\.2px\\] {
  line-height: 25.2px;
}
.leading-\\[27\\.49px\\] {
  line-height: 27.49px;
}
.text-\\[\\#000000\\] {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-\\[\\#006747\\] {
  --tw-text-opacity: 1;
  color: rgb(0 103 71 / var(--tw-text-opacity));
}
.text-\\[\\#09694A\\] {
  --tw-text-opacity: 1;
  color: rgb(9 105 74 / var(--tw-text-opacity));
}
.text-\\[\\#16A2D5\\] {
  --tw-text-opacity: 1;
  color: rgb(22 162 213 / var(--tw-text-opacity));
}
.text-\\[\\#1D1D1D\\] {
  --tw-text-opacity: 1;
  color: rgb(29 29 29 / var(--tw-text-opacity));
}
.text-\\[\\#2F2F2F\\] {
  --tw-text-opacity: 1;
  color: rgb(47 47 47 / var(--tw-text-opacity));
}
.text-\\[\\#333333\\] {
  --tw-text-opacity: 1;
  color: rgb(51 51 51 / var(--tw-text-opacity));
}
.text-\\[\\#333\\] {
  --tw-text-opacity: 1;
  color: rgb(51 51 51 / var(--tw-text-opacity));
}
.text-\\[\\#353535\\] {
  --tw-text-opacity: 1;
  color: rgb(53 53 53 / var(--tw-text-opacity));
}
.text-\\[\\#59BF87\\] {
  --tw-text-opacity: 1;
  color: rgb(89 191 135 / var(--tw-text-opacity));
}
.text-\\[\\#666666\\] {
  --tw-text-opacity: 1;
  color: rgb(102 102 102 / var(--tw-text-opacity));
}
.text-\\[\\#70B850\\] {
  --tw-text-opacity: 1;
  color: rgb(112 184 80 / var(--tw-text-opacity));
}
.text-\\[\\#828282\\] {
  --tw-text-opacity: 1;
  color: rgb(130 130 130 / var(--tw-text-opacity));
}
.text-\\[\\#FBAE3B\\] {
  --tw-text-opacity: 1;
  color: rgb(251 174 59 / var(--tw-text-opacity));
}
.text-\\[\\#fff\\] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-blue-300 {
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}
.text-red-400 {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.opacity-0 {
  opacity: 0;
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

body {
  margin: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

* {
  font-family: "Plus Jakarta Sans", sans-serif !important;
}

.loader {
  .ant-modal-content {
    display: contents !important;
  }

  .ant-modal-body {
    display: flex !important;
    justify-content: center !important;
  }
}

.Container {
  padding: 20px !important;
  background-color: #fff;
  border-radius: 20px !important;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.16),
    0px 0px 8px 0px rgba(0, 0, 0, 0.04);
}

.maindiv {
  overflow-x: auto;
}

.ant-table-content {
  .ant-table-measure-row {
    display: none !important;
  }

  table {
    table-layout: auto !important;
    border-spacing: 0;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
    width: 100%;
    border: 1px solid #d9dde6;
    margin-top: 1rem;

    thead {
      border: 1px solid #171624 !important;
    }

    th {
      font-size: 16px;
      line-height: 16px;
      font-style: normal;
      font-weight: 600 !important;
      color: #333 !important;
      background-color: #f1f5ff !important;
      border-right: 1px solid #e9e7f5;
    }

    tr {
      border: 1px black;
    }

    td {
      font-size: 16px;
      line-height: 22px;
      font-style: normal;
      font-weight: 500;
      border-right: 1px solid #e9e7f5;
      color: #333;
      background-color: #fff !important;
      text-align: left;
      padding: 15px !important;
    }
  }
}

.filterContainer {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}

.filter-field {
  opacity: 100;
  transition: opacity 0.3s;
}

/* .filter {
  margin-top: 8px !important;
} */

.placeholder {
  color: #0a0033;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.filterbtn {
  background-color: #f6f6f7 !important;
  border-radius: 4px !important;
  border: 1px solid #c9cccf !important;
  color: #0a0033 !important;
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  width: max-content;
  display: flex;
  align-items: center;
  padding: 6px 8px;
  height: auto;
}

.goBtn {
  width: max-content;
  border: 1px solid #199fda !important;
  border-radius: 4px !important;
  height: auto !important;
  color: #199fda !important;
  font-weight: 500;
}

.clearBtn {
  border-radius: 4px !important;
  height: auto !important;
  border-color: #d9d9d9 !important;
  color: #999999 !important;
}

.mainContainer {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.secondaryContainer {
  position: relative;
  display: flex;
  align-items: center;

  .ant-input-affix-wrapper {
    height: 36px;
    padding: 5px;

    .ant-input {
      width: 100%;
      font-size: 16px;
      outline: none;
      height: auto;
    }

    .ant-input:focus {
      color: #333;

      border-color: #0069d9;
    }
  }
}

/* Export Container */
.exportContainer {
  display: flex;
  margin-left: 10px;

  .commonButton {
    height: 36px;
    background-color: #59bf87 !important;

    &:hover {
      background-color: #59bf87 !important;
    }
  }
}

.pagination {
  padding-top: 20px;
  display: flex;
  justify-content: end;
}

.cancleBtnViewWidth {
  border-radius: 9999px;
  margin-top: 4px;
  margin-bottom: 4px;
  width: 50%;
}

.cancleBtnwidth {
  border-radius: 9999px;
  margin-top: 4px;
  margin-bottom: 4px;
  width: 100%;
}

.saveBtn {
  width: 100% !important;
  border-radius: 9999px;
  background-color: #1677ff;
  margin-top: 4px;
  margin-bottom: 4px;
}

.cancleBtnAction {
  width: 100%;
  border-radius: 9999px;
  margin-top: 4px;
  margin-bottom: 4px;
}

.saveBtnAction {
  width: 100%;
  background-color: rgb(239 68 68);
  border-radius: 9999px;
  margin-top: 4px;
  margin-bottom: 4px;
}

.saveBtnAction:hover {
  background-color: rgb(248 113 113) !important;
}

.popupMain {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.viewUser,
.editUser,
.deleteUser {
  width: calc(100% - 20px);
  font-size: 14px;
  line-height: 39px;
  color: #666666;
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  align-items: center;
  gap: 7px;
  cursor: pointer;
}

.viewUser {
  border-top-left-radius: 1rem;
  /* 16px */
  border-top-right-radius: 1rem;
  /* 16px */
  border-bottom: 1px solid #d7d8e4;
}

.viewUser:hover {
  background-color: #0ea5e9;
  color: #ffffff;
}

.editUser {
  border-bottom: 1px solid #d7d8e4;
}

.editUser:hover {
  background-color: #0ea5e9;
  color: #ffffff;
}

.deleteUser {
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}

.deleteUser:hover {
  background-color: #0ea5e9;
  color: #ffffff;
}

.selectContainer {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.custom-filter-dropdown {
  height: auto;

  .ant-select-selector {
    border-radius: 4px;
    border: 1px solid #d9d9d9 !important;
  }
}

.custom-date-range-picker {
  border-radius: 4px;
  color: #000;
  border: 1px solid #d9d9d9 !important;

  .ant-picker-input {
    color: #000;

    input::placeholder {
      color: #000;
    }
  }
}

.custom-avatar {
  background: #d3d3d3;
  border-radius: 8px;
}

.slidebar {
  width: 20%;
}

.mainTitledefaultClass {
  align-items: center;
  text-align: center;
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 700;
  font-family: "poppins";
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.descriptiondefaultClass {
  align-items: center;
  text-align: center;
  font-weight: 500;
  font-family: "poppins";
  color: rgb(107, 114, 128);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.btnContainer {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 0.75rem;
}

.cancelBtndefautClass {
  width: 100%;
  border-radius: 9999px;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}

.saveBtndefautClass {
  width: 100%;
  border-radius: 9999px;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
  background-color: rgb(239, 68, 68) !important;
}

.saveBtndefautClass:hover {
  background-color: rgb(239, 68, 68) !important;
}

.assignNutritionist {
  display: flex !important;
  flex-direction: column !important;
  justify-content: start !important;
  align-items: start !important;
}

.gradient-range {
  position: relative;
  width: 100%;
  height: 40px;
}

.labels {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
}

.current-value {
  position: absolute;
  top: -45px;
  padding: 2px 5px;
}

.rangeBorderContainer {
  padding: 10px;
  max-width: 100%;
  margin: auto;
}

.h2ScoreRangeText {
  font-size: 24px;
  font-weight: bold;
}

.infoContainer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 10px 0;
}

.scoreTypeText {
  color: #333;
  margin: 0 5px;
}

.colorRangeContainer {
  display: flex;
  flex-direction: row;
  margin: 5px;
}

.indicter {
  display: flex;
}

.colorRangeItem {
  flex: 1 1;
}

.colorRangeView {
  height: 9.52px;
}

.scoreRangeView {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.scoreTypeText {
  font-size: 12px;
}

.hover\\:cursor-pointer:hover {
  cursor: pointer;
}

.hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity));
}

.hover\\:text-\\[\\#333\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(51 51 51 / var(--tw-text-opacity));
}

.hover\\:text-\\[\\#59BF87\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(89 191 135 / var(--tw-text-opacity));
}

.hover\\:text-\\[blue\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(0 0 255 / var(--tw-text-opacity));
}

.hover\\:text-\\[red\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(255 0 0 / var(--tw-text-opacity));
}

.hover\\:text-blue-700:hover {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity));
}

.disabled\\:bg-blue-200:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity));
}

@media (min-width: 768px) {

  .md\\:mb-0 {
    margin-bottom: 0px;
  }

  .md\\:mr-6 {
    margin-right: 1.5rem;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:mt-\\[-20px\\] {
    margin-top: -20px;
  }

  .md\\:\\!h-\\[145px\\] {
    height: 145px !important;
  }

  .md\\:h-\\[150px\\] {
    height: 150px;
  }

  .md\\:h-\\[30px\\] {
    height: 30px;
  }

  .md\\:\\!w-\\[145px\\] {
    width: 145px !important;
  }

  .md\\:w-\\[130px\\] {
    width: 130px;
  }

  .md\\:w-\\[30px\\] {
    width: 30px;
  }

  .md\\:w-\\[70\\%\\] {
    width: 70%;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:gap-\\[20px\\] {
    gap: 20px;
  }

  .md\\:gap-\\[30px\\] {
    gap: 30px;
  }

  .md\\:p-\\[20px\\] {
    padding: 20px;
  }

  .md\\:px-\\[20px\\] {
    padding-left: 20px;
    padding-right: 20px;
  }

  .md\\:pl-0 {
    padding-left: 0px;
  }

  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-\\[14px\\] {
    font-size: 14px;
  }

  .md\\:text-\\[16px\\] {
    font-size: 16px;
  }

  .md\\:text-\\[20px\\] {
    font-size: 20px;
  }

  .md\\:leading-\\[22\\.68px\\] {
    line-height: 22.68px;
  }

  .md\\:leading-\\[22px\\] {
    line-height: 22px;
  }

  .md\\:leading-\\[25\\.2px\\] {
    line-height: 25.2px;
  }
}

@media (min-width: 1024px) {

  .lg\\:mt-0 {
    margin-top: 0px;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:\\!w-fit {
    width: -moz-fit-content !important;
    width: fit-content !important;
  }

  .lg\\:w-1\\/2 {
    width: 50%;
  }

  .lg\\:w-\\[170px\\] {
    width: 170px;
  }

  .lg\\:w-\\[500px\\] {
    width: 500px;
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:items-center {
    align-items: center;
  }

  .lg\\:justify-center {
    justify-content: center;
  }

  .lg\\:rounded-\\[20px\\] {
    border-radius: 20px;
  }

  .lg\\:border-b {
    border-bottom-width: 1px;
  }

  .lg\\:border-none {
    border-style: none;
  }

  .lg\\:bg-\\[\\#F7F7F7\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(247 247 247 / var(--tw-bg-opacity));
  }

  .lg\\:px-\\[20px\\] {
    padding-left: 20px;
    padding-right: 20px;
  }

  .lg\\:pb-\\[17px\\] {
    padding-bottom: 17px;
  }

  .lg\\:pb-\\[19px\\] {
    padding-bottom: 19px;
  }

  .lg\\:pt-\\[19px\\] {
    padding-top: 19px;
  }

  .lg\\:text-\\[14px\\] {
    font-size: 14px;
  }

  .lg\\:text-\\[16px\\] {
    font-size: 16px;
  }

  .lg\\:text-\\[18px\\] {
    font-size: 18px;
  }

  .lg\\:font-\\[500\\] {
    font-weight: 500;
  }

  .lg\\:font-\\[700\\] {
    font-weight: 700;
  }
}

@media (min-width: 1280px) {

  .xl\\:w-7\\/12 {
    width: 58.333333%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAEd;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;;AAGnB;EACE,SAAS;EACT,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;IACxB,kCAAkC;EACpC;AACF;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,8BAA8B;EAC9B;uCACqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,6BAA6B;IAC7B,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,sCAAsC;IACtC,WAAW;IACX,yBAAyB;IACzB,gBAAgB;;IAEhB;MACE,oCAAoC;IACtC;;IAEA;MACE,eAAe;MACf,iBAAiB;MACjB,kBAAkB;MAClB,2BAA2B;MAC3B,sBAAsB;MACtB,oCAAoC;MACpC,+BAA+B;IACjC;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,eAAe;MACf,iBAAiB;MACjB,kBAAkB;MAClB,gBAAgB;MAChB,+BAA+B;MAC/B,WAAW;MACX,iCAAiC;MACjC,gBAAgB;MAChB,wBAAwB;IAC1B;EACF;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;;GAEG;;AAEH;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,oCAAoC;EACpC,yBAAyB;EACzB,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,6BAA6B;EAC7B,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;;EAEnB;IACE,YAAY;IACZ,YAAY;;IAEZ;MACE,WAAW;MACX,eAAe;MACf,aAAa;MACb,YAAY;IACd;;IAEA;MACE,WAAW;;MAEX,qBAAqB;IACvB;EACF;AACF;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,iBAAiB;;EAEjB;IACE,YAAY;IACZ,oCAAoC;;IAEpC;MACE,oCAAoC;IACtC;EACF;AACF;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;;EAGE,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,SAAS;EACT,6BAA6B;EAC7B,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,YAAY;;EAEZ;IACE,kBAAkB;IAClB,oCAAoC;EACtC;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oCAAoC;;EAEpC;IACE,WAAW;;IAEX;MACE,WAAW;IACb;EACF;AACF;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AA/bA;EAAA;AAgcA;;AAhcA;EAAA,kBAgcA;EAhcA;AAgcA;;AAhcA;EAAA,oBAgcA;EAhcA;AAgcA;;AAhcA;EAAA,oBAgcA;EAhcA;AAgcA;;AAhcA;EAAA,oBAgcA;EAhcA;AAgcA;;AAhcA;EAAA,oBAgcA;EAhcA;AAgcA;;AAhcA;EAAA,oBAgcA;EAhcA;AAgcA;;AAhcA;EAAA,kBAgcA;EAhcA;AAgcA;;AAhcA;;EAAA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA,kBAgcA;IAhcA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA,iBAgcA;IAhcA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;AAAA;;AAhcA;;EAAA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA,kCAgcA;IAhcA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA,kBAgcA;IAhcA;EAgcA;;EAhcA;IAAA,kBAgcA;IAhcA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;AAAA;;AAhcA;;EAAA;IAAA;EAgcA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n@import url(\"https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&display=swap\");\n\nbody {\n  margin: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n* {\n  font-family: \"Plus Jakarta Sans\", sans-serif !important;\n}\n\n.loader {\n  .ant-modal-content {\n    display: contents !important;\n  }\n\n  .ant-modal-body {\n    display: flex !important;\n    justify-content: center !important;\n  }\n}\n\n.Container {\n  padding: 20px !important;\n  background-color: #fff;\n  border-radius: 20px !important;\n  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.16),\n    0px 0px 8px 0px rgba(0, 0, 0, 0.04);\n}\n\n.maindiv {\n  overflow-x: auto;\n}\n\n.ant-table-content {\n  .ant-table-measure-row {\n    display: none !important;\n  }\n\n  table {\n    table-layout: auto !important;\n    border-spacing: 0;\n    border-radius: 10px;\n    overflow: hidden;\n    box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);\n    width: 100%;\n    border: 1px solid #d9dde6;\n    margin-top: 1rem;\n\n    thead {\n      border: 1px solid #171624 !important;\n    }\n\n    th {\n      font-size: 16px;\n      line-height: 16px;\n      font-style: normal;\n      font-weight: 600 !important;\n      color: #333 !important;\n      background-color: #f1f5ff !important;\n      border-right: 1px solid #e9e7f5;\n    }\n\n    tr {\n      border: 1px black;\n    }\n\n    td {\n      font-size: 16px;\n      line-height: 22px;\n      font-style: normal;\n      font-weight: 500;\n      border-right: 1px solid #e9e7f5;\n      color: #333;\n      background-color: #fff !important;\n      text-align: left;\n      padding: 15px !important;\n    }\n  }\n}\n\n.filterContainer {\n  width: 100%;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.filter-field {\n  opacity: 100;\n  transition: opacity 0.3s;\n}\n\n/* .filter {\n  margin-top: 8px !important;\n} */\n\n.placeholder {\n  color: #0a0033;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n}\n\n.filterbtn {\n  background-color: #f6f6f7 !important;\n  border-radius: 4px !important;\n  border: 1px solid #c9cccf !important;\n  color: #0a0033 !important;\n  font-size: 14px !important;\n  font-style: normal !important;\n  font-weight: 400 !important;\n  width: max-content;\n  display: flex;\n  align-items: center;\n  padding: 6px 8px;\n  height: auto;\n}\n\n.goBtn {\n  width: max-content;\n  border: 1px solid #199fda !important;\n  border-radius: 4px !important;\n  height: auto !important;\n  color: #199fda !important;\n  font-weight: 500;\n}\n\n.clearBtn {\n  border-radius: 4px !important;\n  height: auto !important;\n  border-color: #d9d9d9 !important;\n  color: #999999 !important;\n}\n\n.mainContainer {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.secondaryContainer {\n  position: relative;\n  display: flex;\n  align-items: center;\n\n  .ant-input-affix-wrapper {\n    height: 36px;\n    padding: 5px;\n\n    .ant-input {\n      width: 100%;\n      font-size: 16px;\n      outline: none;\n      height: auto;\n    }\n\n    .ant-input:focus {\n      color: #333;\n\n      border-color: #0069d9;\n    }\n  }\n}\n\n/* Export Container */\n.exportContainer {\n  display: flex;\n  margin-left: 10px;\n\n  .commonButton {\n    height: 36px;\n    background-color: #59bf87 !important;\n\n    &:hover {\n      background-color: #59bf87 !important;\n    }\n  }\n}\n\n.pagination {\n  padding-top: 20px;\n  display: flex;\n  justify-content: end;\n}\n\n.cancleBtnViewWidth {\n  border-radius: 9999px;\n  margin-top: 4px;\n  margin-bottom: 4px;\n  width: 50%;\n}\n\n.cancleBtnwidth {\n  border-radius: 9999px;\n  margin-top: 4px;\n  margin-bottom: 4px;\n  width: 100%;\n}\n\n.saveBtn {\n  width: 100% !important;\n  border-radius: 9999px;\n  background-color: #1677ff;\n  margin-top: 4px;\n  margin-bottom: 4px;\n}\n\n.cancleBtnAction {\n  width: 100%;\n  border-radius: 9999px;\n  margin-top: 4px;\n  margin-bottom: 4px;\n}\n\n.saveBtnAction {\n  width: 100%;\n  background-color: rgb(239 68 68);\n  border-radius: 9999px;\n  margin-top: 4px;\n  margin-bottom: 4px;\n}\n\n.saveBtnAction:hover {\n  background-color: rgb(248 113 113) !important;\n}\n\n.popupMain {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.viewUser,\n.editUser,\n.deleteUser {\n  width: calc(100% - 20px);\n  font-size: 14px;\n  line-height: 39px;\n  color: #666666;\n  padding-left: 10px;\n  padding-right: 10px;\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  cursor: pointer;\n}\n\n.viewUser {\n  border-top-left-radius: 1rem;\n  /* 16px */\n  border-top-right-radius: 1rem;\n  /* 16px */\n  border-bottom: 1px solid #d7d8e4;\n}\n\n.viewUser:hover {\n  background-color: #0ea5e9;\n  color: #ffffff;\n}\n\n.editUser {\n  border-bottom: 1px solid #d7d8e4;\n}\n\n.editUser:hover {\n  background-color: #0ea5e9;\n  color: #ffffff;\n}\n\n.deleteUser {\n  border-bottom-right-radius: 1rem;\n  border-bottom-left-radius: 1rem;\n}\n\n.deleteUser:hover {\n  background-color: #0ea5e9;\n  color: #ffffff;\n}\n\n.selectContainer {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.custom-filter-dropdown {\n  height: auto;\n\n  .ant-select-selector {\n    border-radius: 4px;\n    border: 1px solid #d9d9d9 !important;\n  }\n}\n\n.custom-date-range-picker {\n  border-radius: 4px;\n  color: #000;\n  border: 1px solid #d9d9d9 !important;\n\n  .ant-picker-input {\n    color: #000;\n\n    input::placeholder {\n      color: #000;\n    }\n  }\n}\n\n.custom-avatar {\n  background: #d3d3d3;\n  border-radius: 8px;\n}\n\n.slidebar {\n  width: 20%;\n}\n\n.mainTitledefaultClass {\n  align-items: center;\n  text-align: center;\n  font-size: 1.5rem;\n  line-height: 2rem;\n  font-weight: 700;\n  font-family: \"poppins\";\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n}\n\n.descriptiondefaultClass {\n  align-items: center;\n  text-align: center;\n  font-weight: 500;\n  font-family: \"poppins\";\n  color: rgb(107, 114, 128);\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.btnContainer {\n  display: flex;\n  justify-content: center;\n  gap: 0.5rem;\n  margin-top: 0.75rem;\n}\n\n.cancelBtndefautClass {\n  width: 100%;\n  border-radius: 9999px;\n  margin-top: 0.25rem;\n  margin-bottom: 0.25rem;\n}\n\n.saveBtndefautClass {\n  width: 100%;\n  border-radius: 9999px;\n  margin-top: 0.25rem;\n  margin-bottom: 0.25rem;\n  background-color: rgb(239, 68, 68) !important;\n}\n\n.saveBtndefautClass:hover {\n  background-color: rgb(239, 68, 68) !important;\n}\n\n.assignNutritionist {\n  display: flex !important;\n  flex-direction: column !important;\n  justify-content: start !important;\n  align-items: start !important;\n}\n\n.gradient-range {\n  position: relative;\n  width: 100%;\n  height: 40px;\n}\n\n.labels {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 5px;\n}\n\n.current-value {\n  position: absolute;\n  top: -45px;\n  padding: 2px 5px;\n}\n\n.rangeBorderContainer {\n  padding: 10px;\n  max-width: 100%;\n  margin: auto;\n}\n\n.h2ScoreRangeText {\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.infoContainer {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  margin: 10px 0;\n}\n\n.scoreTypeText {\n  color: #333;\n  margin: 0 5px;\n}\n\n.colorRangeContainer {\n  display: flex;\n  flex-direction: row;\n  margin: 5px;\n}\n\n.indicter {\n  display: flex;\n}\n\n.colorRangeItem {\n  flex: 1;\n}\n\n.colorRangeView {\n  height: 9.52px;\n}\n\n.scoreRangeView {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.scoreTypeText {\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
